import { NAV_ITEM_HOME, NAV_ITEM_MONITORING, NAV_ITEMS } from '@/path';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { usePasswordless } from '@verifime/cognito-passwordless-auth';
import { PrintOnlyLogo } from '@verifime/components';
import tokens from '@verifime/design-tokens';
import { useFeatureToggle } from '@verifime/utils';
import { ClientPortalSideNav } from '@verifime/views';
import { useRouter } from 'next/router';
import { PropsWithChildren, useCallback } from 'react';

export default function Layout({ children }: PropsWithChildren) {
  const router = useRouter();
  const { signOut, tokensParsed } = usePasswordless();
  const email = tokensParsed?.idToken?.email || '';

  const signOutAndRedirect = useCallback(() => {
    signOut().signedOut.then(() => {
      router.push('/');
    });
  }, [router, signOut]);

  const { isMonitoringEnabled } = useFeatureToggle();
  const navItems = isMonitoringEnabled
    ? NAV_ITEMS
    : NAV_ITEMS.filter((item) => item !== NAV_ITEM_MONITORING);

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <>
      <div
        style={{
          minHeight: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ display: 'flex', flex: 'auto' }}>
          {/* TODO: TECHNICAL DEBT TD-005 - No mobile navigation */}
          {isDesktop && (
            <ClientPortalSideNav
              navItems={navItems}
              homeNavItem={NAV_ITEM_HOME}
              homePath={NAV_ITEM_HOME.path}
              doSignOut={signOutAndRedirect}
              email={{ value: email }}
            />
          )}
          <Box
            sx={{
              minWidth: tokens.sizeXs,
              padding: { xs: tokens.spacingXs },
              flex: 1,
              paddingBottom: { xs: tokens.spacing4xl, sm: tokens.spacingXs },
            }}
          >
            <PrintOnlyLogo />
            {children}
          </Box>
        </div>
      </div>
    </>
  );
}
